<mat-drawer-container  #routeFormSidenav class="planification-map-container">
    <mat-drawer *ngIf="mapLoaded()" [opened]="sidenavOpened()" [mode]="isMobile() ? 'over' : 'side'" #drawer class="sidenav" (closedStart)="sidenavOpened.set(false)">
        <app-route-form-header />
        <app-route-form *ngIf="!routeFormResults()" [routeFormResults]="routeFormResults" />
        <app-route-results [routeFormResults]="routeFormResults" *ngIf="routeFormResults()" ></app-route-results>
        <app-route-form-footer />

    </mat-drawer>

    <mat-drawer-content>
        <app-map />
    </mat-drawer-content>
  
  
  </mat-drawer-container>